/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as AppRouteImport } from "./routes/_app"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as InvitationsTokenRouteImport } from "./routes/invitations/$token"
import { Route as CallbackGoogleRouteImport } from "./routes/callback.google"
import { Route as AccountVerifyRouteImport } from "./routes/account/verify"
import { Route as AccountSignupRouteImport } from "./routes/account/signup"
import { Route as AccountLoginRouteImport } from "./routes/account/login"
import { Route as AppUsageRouteImport } from "./routes/_app/usage"
import { Route as AppTransactionsRouteImport } from "./routes/_app/transactions"
import { Route as AppRanksRouteImport } from "./routes/_app/ranks"
import { Route as AppProfileRouteImport } from "./routes/_app/profile"
import { Route as AppProductTypesRouteImport } from "./routes/_app/product-types"
import { Route as AppPayoutsRouteImport } from "./routes/_app/payouts"
import { Route as AppPackagesRouteImport } from "./routes/_app/packages"
import { Route as AppNotificationsRouteImport } from "./routes/_app/notifications"
import { Route as AppMembersRouteImport } from "./routes/_app/members"
import { Route as AppIdeasRouteImport } from "./routes/_app/ideas"
import { Route as AppDesignerReportsRouteImport } from "./routes/_app/designer-reports"
import { Route as AppDashboardRouteImport } from "./routes/_app/dashboard"
import { Route as AppCouponsRouteImport } from "./routes/_app/coupons"
import { Route as AppClientReportsRouteImport } from "./routes/_app/client-reports"
import { Route as AppClientRouteImport } from "./routes/_app/client"
import { Route as AppBoardsRouteImport } from "./routes/_app/boards"
import { Route as AppBoardReportsRouteImport } from "./routes/_app/board-reports"
import { Route as AppBillingRouteImport } from "./routes/_app/billing"
import { Route as AppBalanceLogsRouteImport } from "./routes/_app/balance-logs"
import { Route as AppAdminRouteImport } from "./routes/_app/admin"
import { Route as AppAccountsRouteImport } from "./routes/_app/accounts"
import { Route as AppBoardsIndexRouteImport } from "./routes/_app/boards/index"

const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationsTokenRoute = InvitationsTokenRouteImport.update({
  id: "/invitations/$token",
  path: "/invitations/$token",
  getParentRoute: () => rootRouteImport,
} as any)
const CallbackGoogleRoute = CallbackGoogleRouteImport.update({
  id: "/callback/google",
  path: "/callback/google",
  getParentRoute: () => rootRouteImport,
} as any)
const AccountVerifyRoute = AccountVerifyRouteImport.update({
  id: "/account/verify",
  path: "/account/verify",
  getParentRoute: () => rootRouteImport,
} as any)
const AccountSignupRoute = AccountSignupRouteImport.update({
  id: "/account/signup",
  path: "/account/signup",
  getParentRoute: () => rootRouteImport,
} as any)
const AccountLoginRoute = AccountLoginRouteImport.update({
  id: "/account/login",
  path: "/account/login",
  getParentRoute: () => rootRouteImport,
} as any)
const AppUsageRoute = AppUsageRouteImport.update({
  id: "/usage",
  path: "/usage",
  getParentRoute: () => AppRoute,
} as any)
const AppTransactionsRoute = AppTransactionsRouteImport.update({
  id: "/transactions",
  path: "/transactions",
  getParentRoute: () => AppRoute,
} as any)
const AppRanksRoute = AppRanksRouteImport.update({
  id: "/ranks",
  path: "/ranks",
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => AppRoute,
} as any)
const AppProductTypesRoute = AppProductTypesRouteImport.update({
  id: "/product-types",
  path: "/product-types",
  getParentRoute: () => AppRoute,
} as any)
const AppPayoutsRoute = AppPayoutsRouteImport.update({
  id: "/payouts",
  path: "/payouts",
  getParentRoute: () => AppRoute,
} as any)
const AppPackagesRoute = AppPackagesRouteImport.update({
  id: "/packages",
  path: "/packages",
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: "/notifications",
  path: "/notifications",
  getParentRoute: () => AppRoute,
} as any)
const AppMembersRoute = AppMembersRouteImport.update({
  id: "/members",
  path: "/members",
  getParentRoute: () => AppRoute,
} as any)
const AppIdeasRoute = AppIdeasRouteImport.update({
  id: "/ideas",
  path: "/ideas",
  getParentRoute: () => AppRoute,
} as any)
const AppDesignerReportsRoute = AppDesignerReportsRouteImport.update({
  id: "/designer-reports",
  path: "/designer-reports",
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => AppRoute,
} as any)
const AppCouponsRoute = AppCouponsRouteImport.update({
  id: "/coupons",
  path: "/coupons",
  getParentRoute: () => AppRoute,
} as any)
const AppClientReportsRoute = AppClientReportsRouteImport.update({
  id: "/client-reports",
  path: "/client-reports",
  getParentRoute: () => AppRoute,
} as any)
const AppClientRoute = AppClientRouteImport.update({
  id: "/client",
  path: "/client",
  getParentRoute: () => AppRoute,
} as any)
const AppBoardsRoute = AppBoardsRouteImport.update({
  id: "/boards",
  path: "/boards",
  getParentRoute: () => AppRoute,
} as any)
const AppBoardReportsRoute = AppBoardReportsRouteImport.update({
  id: "/board-reports",
  path: "/board-reports",
  getParentRoute: () => AppRoute,
} as any)
const AppBillingRoute = AppBillingRouteImport.update({
  id: "/billing",
  path: "/billing",
  getParentRoute: () => AppRoute,
} as any)
const AppBalanceLogsRoute = AppBalanceLogsRouteImport.update({
  id: "/balance-logs",
  path: "/balance-logs",
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => AppRoute,
} as any)
const AppAccountsRoute = AppAccountsRouteImport.update({
  id: "/accounts",
  path: "/accounts",
  getParentRoute: () => AppRoute,
} as any)
const AppBoardsIndexRoute = AppBoardsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppBoardsRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/accounts": typeof AppAccountsRoute
  "/admin": typeof AppAdminRoute
  "/balance-logs": typeof AppBalanceLogsRoute
  "/billing": typeof AppBillingRoute
  "/board-reports": typeof AppBoardReportsRoute
  "/boards": typeof AppBoardsRouteWithChildren
  "/client": typeof AppClientRoute
  "/client-reports": typeof AppClientReportsRoute
  "/coupons": typeof AppCouponsRoute
  "/dashboard": typeof AppDashboardRoute
  "/designer-reports": typeof AppDesignerReportsRoute
  "/ideas": typeof AppIdeasRoute
  "/members": typeof AppMembersRoute
  "/notifications": typeof AppNotificationsRoute
  "/packages": typeof AppPackagesRoute
  "/payouts": typeof AppPayoutsRoute
  "/product-types": typeof AppProductTypesRoute
  "/profile": typeof AppProfileRoute
  "/ranks": typeof AppRanksRoute
  "/transactions": typeof AppTransactionsRoute
  "/usage": typeof AppUsageRoute
  "/account/login": typeof AccountLoginRoute
  "/account/signup": typeof AccountSignupRoute
  "/account/verify": typeof AccountVerifyRoute
  "/callback/google": typeof CallbackGoogleRoute
  "/invitations/$token": typeof InvitationsTokenRoute
  "/boards/": typeof AppBoardsIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/accounts": typeof AppAccountsRoute
  "/admin": typeof AppAdminRoute
  "/balance-logs": typeof AppBalanceLogsRoute
  "/billing": typeof AppBillingRoute
  "/board-reports": typeof AppBoardReportsRoute
  "/client": typeof AppClientRoute
  "/client-reports": typeof AppClientReportsRoute
  "/coupons": typeof AppCouponsRoute
  "/dashboard": typeof AppDashboardRoute
  "/designer-reports": typeof AppDesignerReportsRoute
  "/ideas": typeof AppIdeasRoute
  "/members": typeof AppMembersRoute
  "/notifications": typeof AppNotificationsRoute
  "/packages": typeof AppPackagesRoute
  "/payouts": typeof AppPayoutsRoute
  "/product-types": typeof AppProductTypesRoute
  "/profile": typeof AppProfileRoute
  "/ranks": typeof AppRanksRoute
  "/transactions": typeof AppTransactionsRoute
  "/usage": typeof AppUsageRoute
  "/account/login": typeof AccountLoginRoute
  "/account/signup": typeof AccountSignupRoute
  "/account/verify": typeof AccountVerifyRoute
  "/callback/google": typeof CallbackGoogleRoute
  "/invitations/$token": typeof InvitationsTokenRoute
  "/boards": typeof AppBoardsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/_app": typeof AppRouteWithChildren
  "/_app/accounts": typeof AppAccountsRoute
  "/_app/admin": typeof AppAdminRoute
  "/_app/balance-logs": typeof AppBalanceLogsRoute
  "/_app/billing": typeof AppBillingRoute
  "/_app/board-reports": typeof AppBoardReportsRoute
  "/_app/boards": typeof AppBoardsRouteWithChildren
  "/_app/client": typeof AppClientRoute
  "/_app/client-reports": typeof AppClientReportsRoute
  "/_app/coupons": typeof AppCouponsRoute
  "/_app/dashboard": typeof AppDashboardRoute
  "/_app/designer-reports": typeof AppDesignerReportsRoute
  "/_app/ideas": typeof AppIdeasRoute
  "/_app/members": typeof AppMembersRoute
  "/_app/notifications": typeof AppNotificationsRoute
  "/_app/packages": typeof AppPackagesRoute
  "/_app/payouts": typeof AppPayoutsRoute
  "/_app/product-types": typeof AppProductTypesRoute
  "/_app/profile": typeof AppProfileRoute
  "/_app/ranks": typeof AppRanksRoute
  "/_app/transactions": typeof AppTransactionsRoute
  "/_app/usage": typeof AppUsageRoute
  "/account/login": typeof AccountLoginRoute
  "/account/signup": typeof AccountSignupRoute
  "/account/verify": typeof AccountVerifyRoute
  "/callback/google": typeof CallbackGoogleRoute
  "/invitations/$token": typeof InvitationsTokenRoute
  "/_app/boards/": typeof AppBoardsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/accounts"
    | "/admin"
    | "/balance-logs"
    | "/billing"
    | "/board-reports"
    | "/boards"
    | "/client"
    | "/client-reports"
    | "/coupons"
    | "/dashboard"
    | "/designer-reports"
    | "/ideas"
    | "/members"
    | "/notifications"
    | "/packages"
    | "/payouts"
    | "/product-types"
    | "/profile"
    | "/ranks"
    | "/transactions"
    | "/usage"
    | "/account/login"
    | "/account/signup"
    | "/account/verify"
    | "/callback/google"
    | "/invitations/$token"
    | "/boards/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/accounts"
    | "/admin"
    | "/balance-logs"
    | "/billing"
    | "/board-reports"
    | "/client"
    | "/client-reports"
    | "/coupons"
    | "/dashboard"
    | "/designer-reports"
    | "/ideas"
    | "/members"
    | "/notifications"
    | "/packages"
    | "/payouts"
    | "/product-types"
    | "/profile"
    | "/ranks"
    | "/transactions"
    | "/usage"
    | "/account/login"
    | "/account/signup"
    | "/account/verify"
    | "/callback/google"
    | "/invitations/$token"
    | "/boards"
  id:
    | "__root__"
    | "/"
    | "/_app"
    | "/_app/accounts"
    | "/_app/admin"
    | "/_app/balance-logs"
    | "/_app/billing"
    | "/_app/board-reports"
    | "/_app/boards"
    | "/_app/client"
    | "/_app/client-reports"
    | "/_app/coupons"
    | "/_app/dashboard"
    | "/_app/designer-reports"
    | "/_app/ideas"
    | "/_app/members"
    | "/_app/notifications"
    | "/_app/packages"
    | "/_app/payouts"
    | "/_app/product-types"
    | "/_app/profile"
    | "/_app/ranks"
    | "/_app/transactions"
    | "/_app/usage"
    | "/account/login"
    | "/account/signup"
    | "/account/verify"
    | "/callback/google"
    | "/invitations/$token"
    | "/_app/boards/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AccountLoginRoute: typeof AccountLoginRoute
  AccountSignupRoute: typeof AccountSignupRoute
  AccountVerifyRoute: typeof AccountVerifyRoute
  CallbackGoogleRoute: typeof CallbackGoogleRoute
  InvitationsTokenRoute: typeof InvitationsTokenRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_app": {
      id: "/_app"
      path: ""
      fullPath: ""
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/invitations/$token": {
      id: "/invitations/$token"
      path: "/invitations/$token"
      fullPath: "/invitations/$token"
      preLoaderRoute: typeof InvitationsTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/callback/google": {
      id: "/callback/google"
      path: "/callback/google"
      fullPath: "/callback/google"
      preLoaderRoute: typeof CallbackGoogleRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/account/verify": {
      id: "/account/verify"
      path: "/account/verify"
      fullPath: "/account/verify"
      preLoaderRoute: typeof AccountVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/account/signup": {
      id: "/account/signup"
      path: "/account/signup"
      fullPath: "/account/signup"
      preLoaderRoute: typeof AccountSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/account/login": {
      id: "/account/login"
      path: "/account/login"
      fullPath: "/account/login"
      preLoaderRoute: typeof AccountLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app/usage": {
      id: "/_app/usage"
      path: "/usage"
      fullPath: "/usage"
      preLoaderRoute: typeof AppUsageRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/transactions": {
      id: "/_app/transactions"
      path: "/transactions"
      fullPath: "/transactions"
      preLoaderRoute: typeof AppTransactionsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/ranks": {
      id: "/_app/ranks"
      path: "/ranks"
      fullPath: "/ranks"
      preLoaderRoute: typeof AppRanksRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/profile": {
      id: "/_app/profile"
      path: "/profile"
      fullPath: "/profile"
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/product-types": {
      id: "/_app/product-types"
      path: "/product-types"
      fullPath: "/product-types"
      preLoaderRoute: typeof AppProductTypesRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/payouts": {
      id: "/_app/payouts"
      path: "/payouts"
      fullPath: "/payouts"
      preLoaderRoute: typeof AppPayoutsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/packages": {
      id: "/_app/packages"
      path: "/packages"
      fullPath: "/packages"
      preLoaderRoute: typeof AppPackagesRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/notifications": {
      id: "/_app/notifications"
      path: "/notifications"
      fullPath: "/notifications"
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/members": {
      id: "/_app/members"
      path: "/members"
      fullPath: "/members"
      preLoaderRoute: typeof AppMembersRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/ideas": {
      id: "/_app/ideas"
      path: "/ideas"
      fullPath: "/ideas"
      preLoaderRoute: typeof AppIdeasRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/designer-reports": {
      id: "/_app/designer-reports"
      path: "/designer-reports"
      fullPath: "/designer-reports"
      preLoaderRoute: typeof AppDesignerReportsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/dashboard": {
      id: "/_app/dashboard"
      path: "/dashboard"
      fullPath: "/dashboard"
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/coupons": {
      id: "/_app/coupons"
      path: "/coupons"
      fullPath: "/coupons"
      preLoaderRoute: typeof AppCouponsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/client-reports": {
      id: "/_app/client-reports"
      path: "/client-reports"
      fullPath: "/client-reports"
      preLoaderRoute: typeof AppClientReportsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/client": {
      id: "/_app/client"
      path: "/client"
      fullPath: "/client"
      preLoaderRoute: typeof AppClientRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/boards": {
      id: "/_app/boards"
      path: "/boards"
      fullPath: "/boards"
      preLoaderRoute: typeof AppBoardsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/board-reports": {
      id: "/_app/board-reports"
      path: "/board-reports"
      fullPath: "/board-reports"
      preLoaderRoute: typeof AppBoardReportsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/billing": {
      id: "/_app/billing"
      path: "/billing"
      fullPath: "/billing"
      preLoaderRoute: typeof AppBillingRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/balance-logs": {
      id: "/_app/balance-logs"
      path: "/balance-logs"
      fullPath: "/balance-logs"
      preLoaderRoute: typeof AppBalanceLogsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/admin": {
      id: "/_app/admin"
      path: "/admin"
      fullPath: "/admin"
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/accounts": {
      id: "/_app/accounts"
      path: "/accounts"
      fullPath: "/accounts"
      preLoaderRoute: typeof AppAccountsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/boards/": {
      id: "/_app/boards/"
      path: "/"
      fullPath: "/boards/"
      preLoaderRoute: typeof AppBoardsIndexRouteImport
      parentRoute: typeof AppBoardsRoute
    }
  }
}

interface AppBoardsRouteChildren {
  AppBoardsIndexRoute: typeof AppBoardsIndexRoute
}

const AppBoardsRouteChildren: AppBoardsRouteChildren = {
  AppBoardsIndexRoute: AppBoardsIndexRoute,
}

const AppBoardsRouteWithChildren = AppBoardsRoute._addFileChildren(
  AppBoardsRouteChildren,
)

interface AppRouteChildren {
  AppAccountsRoute: typeof AppAccountsRoute
  AppAdminRoute: typeof AppAdminRoute
  AppBalanceLogsRoute: typeof AppBalanceLogsRoute
  AppBillingRoute: typeof AppBillingRoute
  AppBoardReportsRoute: typeof AppBoardReportsRoute
  AppBoardsRoute: typeof AppBoardsRouteWithChildren
  AppClientRoute: typeof AppClientRoute
  AppClientReportsRoute: typeof AppClientReportsRoute
  AppCouponsRoute: typeof AppCouponsRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppDesignerReportsRoute: typeof AppDesignerReportsRoute
  AppIdeasRoute: typeof AppIdeasRoute
  AppMembersRoute: typeof AppMembersRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppPackagesRoute: typeof AppPackagesRoute
  AppPayoutsRoute: typeof AppPayoutsRoute
  AppProductTypesRoute: typeof AppProductTypesRoute
  AppProfileRoute: typeof AppProfileRoute
  AppRanksRoute: typeof AppRanksRoute
  AppTransactionsRoute: typeof AppTransactionsRoute
  AppUsageRoute: typeof AppUsageRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountsRoute: AppAccountsRoute,
  AppAdminRoute: AppAdminRoute,
  AppBalanceLogsRoute: AppBalanceLogsRoute,
  AppBillingRoute: AppBillingRoute,
  AppBoardReportsRoute: AppBoardReportsRoute,
  AppBoardsRoute: AppBoardsRouteWithChildren,
  AppClientRoute: AppClientRoute,
  AppClientReportsRoute: AppClientReportsRoute,
  AppCouponsRoute: AppCouponsRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppDesignerReportsRoute: AppDesignerReportsRoute,
  AppIdeasRoute: AppIdeasRoute,
  AppMembersRoute: AppMembersRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppPackagesRoute: AppPackagesRoute,
  AppPayoutsRoute: AppPayoutsRoute,
  AppProductTypesRoute: AppProductTypesRoute,
  AppProfileRoute: AppProfileRoute,
  AppRanksRoute: AppRanksRoute,
  AppTransactionsRoute: AppTransactionsRoute,
  AppUsageRoute: AppUsageRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AccountLoginRoute: AccountLoginRoute,
  AccountSignupRoute: AccountSignupRoute,
  AccountVerifyRoute: AccountVerifyRoute,
  CallbackGoogleRoute: CallbackGoogleRoute,
  InvitationsTokenRoute: InvitationsTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
